import React from "react";
import ReactDOM from "react-dom";
import App from "./WeddingCard/App";

ReactDOM.render(<App />, document.getElementById("root"));
